import { observable } from "mobx";
import AgendamentoContainerService from "../../../../../services/AgendamentoContainerService";

export default class RetiradaDryStore {



    @observable booking;
    @observable qtdDisponivel;
    @observable isReefer;
    @observable tiposCntr;

    @observable armador;
    @observable operacao;
    @observable pod;
    @observable destino;

    @observable saldo;

    constructor() {
        this.booking = [];
        this.qtdDisponivel = [];
        this.isReefer = [];
        this.tiposCntr = [];
        this.tiposCntrVisible = []; 
        this.dadosTipoCntrBooking = [];
        this.dadosTipoCntrBookingVisible = [];

        this.armador = [];
        this.operacao = [];
        this.pod = [];
        this.destino = [];

        this.saldo = [];

        this.payload = [];

        this.atualizaDados = true;
        this.adicionaNovoItemRetirada();
        this.service = new AgendamentoContainerService();
    };

    adicionaNovoItemRetirada = () => {
        this.booking.push([]);
        this.qtdDisponivel.push([]);   
        this.isReefer.push([]);   
        this.tiposCntr.push([]);
        this.tiposCntrVisible.push(false);
        this.dadosTipoCntrBooking.push(false);
        this.dadosTipoCntrBookingVisible.push(false);

        this.armador.push([]);
        this.operacao.push([]);
        this.pod.push([]);
        this.destino.push([]);

        this.payload.push([]);
    };

    removerItemRetirada = (index) => {
        this.booking.splice(index, 1);
        this.qtdDisponivel.splice(index, 1);  
        this.isReefer.splice(index, 1);
        this.tiposCntr.splice(index, 1);
        this.tiposCntrVisible.splice(index, 1);
        this.dadosTipoCntrBooking.splice(index, 1);
        this.dadosTipoCntrBookingVisible.splice(index, 1);

        this.armador.splice(index, 1);
        this.operacao.splice(index, 1);
        this.pod.splice(index, 1);
        this.destino.splice(index, 1);
        this.payload.splice(index, 1);

    };

    carregarDadosBooking = (booking, index, dadosAgendamento, controller, atualizarAgendamento = true) => {
        if(atualizarAgendamento){
            this.armador[index] = null;
            this.operacao[index] = null;
            this.pod[index] = null;
            this.destino[index] = null;
            this.payload[index] = null;
            this.dadosTipoCntrBooking[index] = null;
            _.set(dadosAgendamento, `listaBookings[0].containers[${index}].ArmIdDepot`, null);
            _.set(dadosAgendamento, `listaBookings[0].containers[${index}].VesselvisitId`, null);
            _.set(dadosAgendamento, `listaBookings[0].containers[${index}].QtdRetirada`, null);
            _.set(dadosAgendamento, `listaBookings[0].containers[${index}].PayloadMgw`, null);
        }

        if(booking) {
            this.service.buscarDadosPorBookingDepot(booking).then(response => {
                if (response && response.data) {
                    if((response.data.QtdCntr - response.data.QtdDentro) < 1) controller.listaMensagens = ["O booking deve possuir um saldo maior que 0"];
                    else {
                        this.armador[index] = {ArmIdDepot: response.data.ArmId, ApelidoArmador: response.data.ApelidoArmador };
                        this.operacao[index] = {CodViagem: response.data.CodViagem, NavioViagem: response.data.NavioViagem };
                        this.pod[index] = {CodPortoOrig: response.data.CodPortoOrig, DescPortoOrig: response.data.DescPortoOrig };
                        this.destino[index] = {CodPortoDest: response.data.CodPortoDest, DescPortoDest: response.data.DescPortoDest };

                        this.saldo[index] = response.data.QtdCntr - response.data.QtdDentro;
                        
                        _.set(dadosAgendamento, `listaBookings[0].containers[${index}].ArmIdDepot`, response.data.ArmId);
                        _.set(dadosAgendamento, `listaBookings[0].containers[${index}].VesselvisitId`, response.data.CodViagem);    
                    }                                
                } else {
                    this.dadosTipoCntrBooking[index] = "Booking não encontrado.";
                }
            }).catch( erro => {
                console.log(erro)
            });
        }
    };

    limparCampos = (dadosAgendamento, index) => {
        _.set(dadosAgendamento, `listaBookings[0].containers[${index}].ArmIdDepot`, null);
        _.set(dadosAgendamento, `listaBookings[0].containers[${index}].VesselvisitId`, null);
        _.set(dadosAgendamento, `listaBookings[0].containers[${index}].QtdRetirada`, null);
        _.set(dadosAgendamento, `listaBookings[0].containers[${index}].PayloadMgw`, null);
    }

    carregarTiposCntrPorBooking = (booking, index, dadosAgendamento, atualizarAgendamento = true) => {
        if(atualizarAgendamento) {
            this.tiposCntr[index] = [];
            //this.qtdDisponivel[index] = null;
            //this.isReefer[index] = null;
            _.set(dadosAgendamento, `listaBookings[0].containers[${index}].CdTipoCntr`, null);
        }

        if(booking) {
            this.service.buscarTiposCntrPorBookingDepot(booking).then(response => {
                if (response && response.data){
                    this.tiposCntr[index] = response.data;
                    if(response.data.length === 1 && "N" === response.data[0].FlgRefrigCntr){
                        if(atualizarAgendamento) {
                            _.set(dadosAgendamento, `listaBookings[0].containers[${index}].CdTipoCntr`, response.data[0].CodTipoCntr);
                        }
                        //this.qtdDisponivel[index] = response.data[0].Quantidade;
                        //this.isReefer[index] = "S" === response.data[0].FlgRefrigCntr;
                    }
                }
            }).catch( erro => {
                this.tiposCntr[index] = [];
            });
        }
    };

}


// WEBPACK FOOTER //
// ./src/modules/agendamento/containers-cadastrar/retirada-containers-dry/stores/RetiradaDepotDryStore.js